<template>
  <div class="about">
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-card           v-bind="attrs"
          v-on="on"> this is a card</v-card>
        <!-- <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Open Dialog
        </v-btn> -->
      </template>
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Settings</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              dark
              text
              @click="dialog = false"
            >
              Save
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
  stuff here
      </v-card>
    </v-dialog>
</div>

</template>

<script>
export default {
  name: "about",

  data() {
    return {
      dialog: false
    };
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
body {
  background: green;
}
.org-description {
  margin-top: 50px;
}
</style>
